import dynamic from "next/dynamic"
import classNames from "classnames"
import { usePropsObject } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import styles from "./article-teasers.module.css"
import Button from "@/common/button/button"

const Cards = {
  post: dynamic(() => import("@/common/cards/article/article")),
  event: dynamic(() => import("@/common/cards/event/event"))
}

export default function ArticleTeasers({ block }) {
  const { attrs } = block
  const { theme } = usePropsObject()

  if (attrs.articles.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      width="bleed"
      gap={attrs?.blockGap ?? "normal"}
      innerWrapper={true}
      className={classNames(styles.wrapper, "bg-color-" + attrs.bgColor, {
        "text-white": theme?.bgColor === "black"
      })}>
      {(attrs.heading || attrs.category.label) && (
        <h2>
          {attrs.heading}
          {attrs?.showExtraHeading && (
            <a className="term" href={attrs.category.url}>
              {attrs.category.label}
            </a>
          )}
        </h2>
      )}
      {attrs?.text && <p dangerouslySetInnerHTML={{ __html: attrs.text }}></p>}
      <ul>
        {attrs.articles.map((post, index) => {
          const Card = Cards[attrs.type] ?? NotFound
          return (
            <li key={index}>
              <Card
                post={post}
                showTag={attrs?.showTag}
                showExcerpt={attrs?.showExcerpt}
                showDateline={attrs?.showDateline}
              />
            </li>
          )
        })}
      </ul>
      <div className="button-wrapper">
        {attrs?.showButton && attrs?.button?.url && (
          <Button
            tagName="a"
            href={attrs?.button?.url}
            target={attrs?.button?.target ? "_blank" : null}
            rel={
              (attrs?.button?.nofollow ? "nofollow " : "") +
              (attrs?.button?.sponsored ? "sponsored" : "")
            }
            theme={attrs?.button?.theme ?? "lime"}>
            {attrs?.button?.label}
          </Button>
        )}
      </div>
    </Block>
  )
}

const NotFound = () => {
  return null
}
